import { useEffect } from 'react';

const APP_NAME = 'ARCA Academy';

// Tarayıcı sekmesinde açık sayfanın adını gösterir: "Kişi Raporu · ARCA Academy"
export default function usePageTitle(title) {
    useEffect(() => {
        if (!title) return undefined;
        const previous = document.title;
        document.title = `${title} · ${APP_NAME}`;
        return () => { document.title = previous; };
    }, [title]);
}
